import { useSelector } from 'react-redux'
import { Alert, Box, CircularProgress, Typography } from '@mui/material'
import { selectLoading, selectError, selectRows } from '../reducers/dataIntegrityReducer'
import DataIntegrityHeatmap   from './charts/DataIntegrityHeatmap'
import DataIntegrityDrillDown from './charts/DataIntegrityDrillDown'

function DataIntegrityView() {
  const loading = useSelector(selectLoading)
  const error   = useSelector(selectError)
  const rows    = useSelector(selectRows)

  if (loading) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
      <CircularProgress size={32} />
    </Box>
  )

  if (error) return (
    <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>
  )

  if (!rows.length) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
      <Typography variant="body2" color="text.secondary">
        Select filters to view data.
      </Typography>
    </Box>
  )

  return (
    <Box>
      <DataIntegrityHeatmap />
      <DataIntegrityDrillDown />
    </Box>
  )
}

const DataIntegrity = () => <DataIntegrityView />
export default DataIntegrity